import React, { memo, useState, useEffect } from 'react';
import { useImmer } from "use-immer";
import moment from 'moment-business-days';
import { CodingEventService, CodingWorksheetService } from '../../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { Alert, Col, Row, Button, Form, FormControl } from 'react-bootstrap'


const CodingEventNotes = (props) => {

    //const [newNote, setNewNote] = useImmer('');
    const [newNoteError, setNewNoteError] = useImmer('');
    const formHandler = props.formHandler;

    //useEffect(() => {
    //    props.formHandler.setFieldValue('newNote', '', false)
    //},[])

    const saveNote = async () => {
        var newNote = formHandler.values.newNote;

        var eventService = new CodingEventService();
        var result = await eventService.addNote({
            note: newNote,
            codingEventId: props.codingEventId
        });
        if (result.result === true) {
            //setNewNote('');
            setNewNoteError('');
            props.onNoteAdded(result.model);           
        } else if (result.result === false) {
            setNewNoteError("Failed to save note.");
        }
    }

    const onBlurNewNote = (e) => {
        formHandler.handleBlur(e);
    }

    const updateNewNote = (e) => {
        formHandler.handleChange(e);
        //e.target.value
        //onChange = { props.formHandler.handleChange }
        //onBlur = { props.formHandler.handleBlur }
    }

    const deleteNote = async (id) => {
        var eventService = new CodingEventService();
        var callResult = await eventService.deleteNote(id, props.codingEventId);
        if (callResult.result === true) {
            props.onNoteDeleted(id);
            setNewNoteError('');
        } else {
            setNewNoteError("Failed to save note.");
        }
    }

    return (
        <table className='table' aria-labelledby="tabelLabel">
            <tbody>
                {
                    props.notes.map((note) =>
                        note.state === 100 ?
                            <tr key={note.id}>
                                <td><div style={{ whiteSpace: "pre-line" }}>{note.note}</div>
                                    <small>Created By: {note.createdBy} on {moment(note.dateCreated).format('MM/DD/YYYY h:mm a')}</small>
                                </td>
                                <td className="table-fit">
                                    <FontAwesomeIcon icon={faTimesCircle} onClick={() => deleteNote(note.id)} className="danger-icon givemethefinger" />
                                </td>
                            </tr> : null
                    )}
                <tr>
                    <td colSpan="2">
                        <Row>
                            <Form.Group as={Col} lg="11" md="11">
                                <Form.Control placeholder="Enter a new note..."
                                    as="textarea"
                                    rows="4"
                                    minLength="20"
                                    name="newNote"
                                    id="newNote"
                                    value={formHandler.values.newNote}
                                    isValid={formHandler.values.newNote.length > 19}
                                    isInvalid={formHandler.errors.newNote && formHandler.touched.newNote}
                                    onBlur={(e) => onBlurNewNote(e)}
                                    onChange={(e) => updateNewNote(e)} />
                                <FormControl.Feedback type="invalid">
                                    {formHandler.errors.newNote}
                                </FormControl.Feedback>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Alert variant="danger" transition={true} show={newNoteError}>{newNoteError}</Alert>&nbsp;
                                <Button className="ml-auto" disabled={formHandler.values.newNote.length < 20} onClick={() => saveNote()} variant="success">Save</Button>
                            </Form.Group>
                        </Row>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

export default CodingEventNotes;